<template>
  <el-dialog
    :visible.sync="modelVisible"
    width="552px"
    :footer="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="dialog-title">
        <div class="dialog-title_desc">
          {{ title }}
        </div>
        <closeIcon @click="handleClose" />
      </div>
    </template>
    <el-form
      :model="formData"
      :rules="rules"
      label-position="top"
      ref="form"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="11">
        <el-col :span="12">
          <el-form-item prop="firstName">
            <template #label>
              <span class="smbsales-label_required">First Name</span>
            </template>
            <el-input v-model="formData.firstName" @blur="(e)=>formData.firstName = e.target.value.trim()" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="lastName">
            <template #label>
              <span class="smbsales-label_required">Last Name</span>
            </template>
            <el-input v-model.trim="formData.lastName" @blur="(e)=>formData.lastName = e.target.value.trim()" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="position">
        <template #label>
          <span class="smbsales-label_required">Job Title</span>
        </template>
        <el-input v-model.trim="formData.position" />
      </el-form-item>
      <el-form-item prop="email">
        <template #label>
          <span class="smbsales-label_required">Work Email</span>
        </template>
        <el-input v-model.trim="formData.email" />
      </el-form-item>
      <el-form-item label="Office Phone" class="office-phone">
        <el-row :gutter="6">
          <el-col :span="6">
            <el-form-item prop="countryCode">
              <template #label>
                <span class="el-form_font_black">
                  Country Code
                </span>
              </template>
              <el-input-number
                style="width: 100%;"
                :controls="false"
                :precision="0"
                :min="0"
                v-model.trim="formData.countryCode"
                @change="(value) => handleInputNumberChange(value, 'countryCode')"
                placeholder="Required"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="stateNumber">
              <template #label>
                <span class="el-form_font_black">
                  State Number
                </span>
              </template>
              <el-input-number
                :controls="false"
                style="width: 100%;"
                :precision="0"
                :min="0"
                v-model="formData.stateNumber"
                @change="(value) => handleInputNumberChange(value, 'stateNumber')"
                placeholder="Optional"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="telephone">
              <template #label>
                <span class="el-form_font_black">
                  Phone Number
                </span>
              </template>
              <el-input-number
                :controls="false"
                :precision="0"
                :min="0"
                style="width: 100%;"
                v-model="formData.telephone"
                @change="(value) => handleInputNumberChange(value, 'telephone')"
                placeholder="Required"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="extension" label="Extension">
              <template #label>
                <span class="el-form_font_black">
                  Extension
                </span>
              </template>
              <el-input-number
                style="width: 100%;"
                :controls="false"
                :precision="0"
                :min="0"
                v-model="formData.extension"
                @change="(value) => handleInputNumberChange(value, 'extension')"
                placeholder="Optional"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="handleSubmit">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CloseIcon from "./closeIcon.vue";

export default {
  name: "AddContactsModel",
  components: { CloseIcon },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        firstName: void 0, // 姓
        lastName: void 0, // 名
        position: void 0, // 职位
        email: void 0, // 邮箱
        generalManagerName: void 0, // 总经理姓名
        countryCode: void 0, // 国家代码
        stateNumber: void 0, // 州号码
        telephone: void 0, // 电话号码
        extension: void 0, // 分机号码
        userStatus: 0 // 普通联系人
      },
      modelVisible: false
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(visible) {
        this.modelVisible = visible;
      }
    },
    modelVisible(visible) {
      this.$emit("update:visible", visible);
    },
    "formData.countryCode"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("telephone");
      });
    },
    "formData.stateNumber"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
        this.$refs.form.validateField("telephone");
      });
    },
    "formData.telephone"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
      });
    },
    "formData.extension"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
        this.$refs.form.validateField("telephone");
      });
    }
  },
  computed: {
    title() {
      return this.isEdit ? "Edit Contact" : "Add New Contact";
    },
    rules() {
      return {
        firstName: [
          {
            required: true,
            message: "please input firstName",
            trigger: ["change"]
          }
        ],
        lastName: [
          {
            required: true,
            message: "please input lastName",
            trigger: ["change"]
          }
        ],
        position: [
          {
            required: true,
            message: "please input job title",
            trigger: ["change"]
          }
        ],
        email: [
          {
            type: "email",
            message: "please input right work email",
            trigger: ["blur"]
          },
          {
            required: true,
            message: "please input work email",
            trigger: ["change"]
          }
        ],
        countryCode: [
          {
            required:
              !!this.formData.countryCode ||
              !!this.formData.stateNumber ||
              !!this.formData.telephone ||
              !!this.formData.extension,
            message: "please input country code",
            trigger: ["blur"]
          }
        ],
        stateNumber: [
          {
            required: false,
            message: "please input state number",
            trigger: ["blur"]
          }
        ],
        telephone: [
          {
            required:
              !!this.formData.countryCode ||
              !!this.formData.stateNumber ||
              !!this.formData.telephone ||
              !!this.formData.extension,
            message: "please input phone number",
            trigger: ["blur"]
          }
        ],
        extension: [
          {
            required: false,
            message: "please input extension",
            trigger: ["blur"]
          }
        ]
      };
    }
  },
  methods: {
    setFormData(formData) {
      if (!formData) return;
      const info = JSON.parse(JSON.stringify(formData));
      this.formData = {
        ...info,
        countryCode: info.countryCode || void 0,
        stateNumber: info.stateNumber ||  void 0,
        telephone: info.telephone ||  void 0,
        extension: info.extension ||  void 0,
      }
      this.$refs.form && this.$refs.form.clearValidate();
    },
    handleInputNumberChange(val, type) {
      if (!val || !val.toString().trim()) {
        this.$nextTick(() => {
          this.formData[type] = void 0;
        });
      }
    },
    handleClose() {
      this.formData = {
        firstName: void 0, // 姓
        lastName: void 0, // 名
        position: void 0, // 职位
        email: void 0, // 邮箱
        generalManagerName: void 0,
        countryCode: void 0, // 国家代码
        stateNumber: void 0, // 州号码
        telephone: void 0, // 电话号码
        extension: void 0, // 分机号码
        userStatus: 0 // 普通联系人
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.modelVisible = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        let formData = JSON.parse(JSON.stringify(this.formData));
        formData.generalManagerName =
          formData.firstName + " " + formData.lastName;
        if (formData.countryCode && formData.telephone) {
          if (formData.stateNumber && formData.extension) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone} ext.${formData.extension}`;
          } else if (formData.stateNumber) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone}`;
          } else if (formData.extension) {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone} ext.${formData.extension}`;
          } else {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone}`;
          }
        }else {
          formData.officePhone = ""
        }
        this.$emit("submit", formData);
        this.handleClose();
      });
    }
  }
};
</script>

<style scoped>
/deep/ .el-dialog__header {
  padding: 20px 18px 20px 20px;
  border-bottom: 1px solid #e1e4e7 !important;
}

/deep/ .el-dialog__body {
  padding: 20px 20px 20px 32px;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #e1e4e7;
  padding: 20px;

  .el-button {
    width: 120px;
    height: 42px;
    font-size: 16px;
  }
}

/deep/ .el-form-item__label {
  font-size: 16px;
  color: #808080;
  font-weight: normal;
  line-height: 150%;
  padding-bottom: 8px;
}

/* 弹窗单独设置样式 */
/deep/ .el-form-item.is-success .el-input__inner {
  border: 1px solid #dcdfe6 !important;
}

/deep/ .el-form-item .el-input__inner {
  height: 32px;
}

/deep/ .el-form-item__content {
  line-height: 32px;
}

/deep/ .el-form-item__content .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 1;
  color: #383838;
}

/deep/ .el-form-item.is-required .el-form-item__label:before {
  display: none !important;
}

/deep/ .smbsales-label_required {
  position: relative;
}

.office-phone > /deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

/deep/ .smbsales-label_required:before {
  position: absolute;
  content: "*";
  color: #e60039;
  left: -10px;
  font-size: 14px;
  top: 2px;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
}

.dialog-title_desc {
  font-size: 18px;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/views/smbSales/components/addContactsDialog.vue